import React, { useEffect, useState } from 'react';
import { createGlobalStyle, StyleSheetManager, ThemeProvider } from "styled-components";
import './App.css';
import { RPChooser } from "./components/RPChooser";
import ClientDataContext from './store/client-data-context';
import { ClientData } from "./store/client-data";
import { Login } from "./features/Login";
import styleConstants from "./styles/constants/style-constants";
import { styleNormaliseTweaks } from "./styles/primitives/global/normalize-tweaks";
import { styleBase } from "./styles/primitives/global/base";
import { Route, Routes } from "react-router-dom";
import { Callback } from "./features/Callback";

const StyleNormaliseTweaks = createGlobalStyle`
  ${ styleNormaliseTweaks }
`;
const StyleBase = createGlobalStyle`
  ${ styleBase }
`;

function getSessionStorageOrDefault(key, defaultValue) {
    const stored = sessionStorage.getItem(key);
    if (!stored) {
        return defaultValue;
    }
    return JSON.parse(stored);
}

function App() {
    const [isClientChosen, setIsClientChosen] = useState(false);

    const [clientData, setClientData] =
        useState(getSessionStorageOrDefault('clientData', {}) as unknown as ClientData);

    useEffect(() => {
        sessionStorage.setItem('clientData', JSON.stringify(clientData));
    }, [clientData]);

    const changeClient = (id) => {
        setClientData(global.demoConfig.clients[id]);
        setStyleConstants(global.demoConfig.clients[id])
        setIsClientChosen(true)
    }

    function setStyleConstants(data: ClientData) {
        styleConstants.colorPatterns.button.primary.background = data.buttonColor
        styleConstants.colorPatterns.button.secondary.background = data.buttonColor
        styleConstants.colorPatterns.pageHeader.main.background = data.headerColor
        styleConstants.colorPatterns.tab.primary.background = data.tabColor
    }


    return (
        <ClientDataContext.Provider value={ {client: clientData, changeClient: changeClient} }>
            <StyleSheetManager disableVendorPrefixes={ true }>
                <ThemeProvider theme={ styleConstants }>
                    <StyleNormaliseTweaks/>
                    <StyleBase theme={ styleConstants }/>
                    <Routes>
                        <Route path="/" element={ <>
                            { isClientChosen ? <Login/> : <RPChooser/> }
                            <div className='d-flex justify-content-end align-items-end'>
                                <button
                                    className='btn btn-link'
                                    onClick={ () => setIsClientChosen(false) }>
                                    Back to client selection
                                </button>
                            </div>
                        </> }/>
                        <Route path="/callback" element={ <Callback/> }/>
                    </Routes>
                </ThemeProvider>
            </StyleSheetManager>
        </ClientDataContext.Provider>
    );
}

export default App;
